import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './HomeIcon.css'; // CSS dedicato all'icona home
import { HomeIcon as HomeSvg } from './FencingIcons';

/**
 * Icona Home fissa visibile in alto a sinistra
 * Fornisce accesso rapido alla home page da qualsiasi schermata
 * Si ridimensiona quando l'utente scorre la pagina verso il basso
 * Non visibile quando l'utente si trova già nella home page
 */
const HomeIcon = () => {
  // Ottiene il percorso corrente
  const location = useLocation();

  // Stato per tracciare se l'utente ha scrollato
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    // Funzione che controlla la posizione dello scroll
    const handleScroll = () => {
      // Se ha scrollato più di 100px, considera scrollato
      const scrolled = window.scrollY > 100;
      setHasScrolled(scrolled);
    };

    // Aggiungi event listener per lo scrolling
    window.addEventListener('scroll', handleScroll);

    // Rimuovi event listener al cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Non mostrare l'icona se siamo nella home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <Link
      to="/"
      className={`home-icon ${hasScrolled ? 'home-icon-scrolled' : ''}`}
      aria-label="Home"
    >
      <HomeSvg style={{ fontSize: 24, color: '#fff' }} />
    </Link>
  );
};

export default HomeIcon;
